import React, { Component } from 'react'
import { FormControl, FormControlLabel, Checkbox } from '@mui/material'

class DisplayItemTimeSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            disable_limit:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.disable_limit === true
                    ? true
                    : false,
        }
    }

    render() {
        const kedo = this.props.kedo

        return (
            <FormControl fullWidth margin="normal">
                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={this.state.disable_limit === true}
                            onChange={(e) => {
                                this.setState({
                                    disable_limit: e.target.checked,
                                })
                                this.props.onChange(
                                    'disable_limit',
                                    e.target.checked
                                )
                            }}
                            name="disable_limit"
                            disabled={this.props.disabled}
                        />
                    }
                    label={kedo.t('Disable limit')}
                    sx={{
                        mb: 0,
                        '& .MuiFormControlLabel-label': {
                            fontSize: '0.875rem',
                            color: 'text.primary',
                        },
                    }}
                />
            </FormControl>
        )
    }
}

export default DisplayItemTimeSettings
